import { useCallback } from 'react';

import {
  CONTENT_IMAGE,
  ACTIVITIES_COMPONENT_TYPE_IMAGE,
} from 'global/constants';
import { DIRECTION_LEFT } from 'webclient.constants';
import { SlideshowSlide, IMAGE_FIELD } from './slideshow.constants';
import { useFileDropperContext } from 'lib/form/file-dropper/file-dropper';
import { FileDropperImage } from 'lib/form/file-dropper/file-dropper-image';
import { ACCEPT_TYPE_IMAGE } from 'lib/form/file-dropper/file-dropper.constants';
import { Box } from 'approot/shared/design-system/box/box.style';
import { getReorderSort } from 'approot/shared/sortable/sortable.utils';
import customNanoId from 'lib/nanoid/nanoid';
import { addImageToSlideshow } from './slideshow.utils';
import {
  useAddImageToNewComponent,
  useFindComponentDimensions,
} from '../component.hooks';
import { useGetInteractiveLessonParams } from 'approot/activity-builder/activity-builder.hooks';

type Props = {
  slideshowComponentId: string;
  sectionId: string;
  sortedSlides: SlideshowSlide[];
  contentId: number;
};

const SlideshowCreateImage = ({
  slideshowComponentId,
  sectionId,
  sortedSlides,
  contentId,
}: Props) => {
  const { clearFile } = useFileDropperContext(IMAGE_FIELD);

  const { contentType } = useGetInteractiveLessonParams();
  const { elementDimensionLabel } =
    useFindComponentDimensions(slideshowComponentId);
  const { addImageToNewComponent, loading, client } = useAddImageToNewComponent(
    {
      onCompleted: clearFile,
    }
  );

  const handleFileChange = useCallback(
    (key: string, fileName: string) => {
      const componentId = customNanoId();
      const sort = getReorderSort(
        sortedSlides || [],
        sortedSlides.length,
        DIRECTION_LEFT
      );

      addImageToNewComponent({
        variables: {
          input: {
            contentId,
            contentType,
            sectionId,
            componentId,
            parentDetails: {
              parentComponentId: slideshowComponentId,
            },
            componentData: {
              type: ACTIVITIES_COMPONENT_TYPE_IMAGE,
              properties: {
                stimulusId: null,
                showCaptionOnLesson: false,
                dimensionData: {
                  width: 1073,
                  height: 352,
                },
              },
              sort,
            },
            imageInput: {
              key,
              imageType: CONTENT_IMAGE,
              data: null,
              fileName,
            },
          },
        },
      }).then(() => {
        addImageToSlideshow({
          client,
          componentId,
          slideshowComponentId,
        });
      });
    },
    [
      addImageToNewComponent,
      client,
      contentId,
      sectionId,
      slideshowComponentId,
      sortedSlides,
      contentType,
    ]
  );

  return (
    <Box $marginBottom={24}>
      <FileDropperImage
        showAcceptExtensions={false}
        name={IMAGE_FIELD}
        inputDataSelector={IMAGE_FIELD}
        accept={[ACCEPT_TYPE_IMAGE]}
        additionalLabel={elementDimensionLabel}
        onChange={handleFileChange}
        isFinishing={loading}
      />
    </Box>
  );
};

export default SlideshowCreateImage;
